import classNames from 'classnames'
import React from 'react'

type Item = {
    value: string
    secondValue?: string
    secondValueColor?: string
}

type Props = {
    label: string
    rowClasses?: string
    classes?: string
    items: Item[]
}

const DataViewBoxWithRows: React.FC<Props> = ({
    items,
    rowClasses,
    classes,
    label
}) => {
    const shouldShow = items.every((item) => {
        return item.value.length > 0
    })

    return (
        <>
            {shouldShow && (
                <div className={classNames('dataViewBoxWithRows', classes)}>
                    <div className="label">{label}</div>
                    {items.map((item) => {
                        const hasSecondValue =
                            item.secondValue && item.secondValueColor
                        return (
                            <div
                                className={classNames('item', rowClasses, {
                                    multiValue: hasSecondValue
                                })}
                                key={item.value}
                            >
                                <div className="value">{item.value}</div>
                                {hasSecondValue && (
                                    <div
                                        className={classNames(
                                            'secondValue',
                                            item.secondValueColor
                                        )}
                                    >
                                        {item.secondValue}
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}
        </>
    )
}

export default DataViewBoxWithRows
